import React, { ChangeEvent, ReactElement, useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Bundle } from "../bundle/Bundle";
import { BundleSelect } from "../bundle/BundleSelect";
import { Product } from "./Product";
import { ProductService } from "./ProductService";

interface IParams {
	onCreate: (product: Product) => void;
}

export const ProductForm = (props: IParams): ReactElement => {
	const [product] = useState<Product>(new Product());
	const [submitting, setSubmitting] = useState(false);
	const nameRef = useRef<HTMLInputElement>(null);
	const productService = new ProductService();

	const handleSubmit = async () => {
		if (!product.name.trim()) {
			nameRef.current?.focus();
			return;
		}
		setSubmitting(true);
		const newProduct = await productService.create(product);
		setSubmitting(false);
		props.onCreate(newProduct);
	};

	return (
		<>
			<h5 className="mb-3" style={{ fontWeight: 600 }}>
				<i className="fa fa-plus-circle" style={{ marginRight: 8, opacity: 0.6 }} />
				New Product
			</h5>
			<Form>
				<Row>
					<Col md={4}>
						<Form.Group>
							<Form.Label>Name</Form.Label>
							<Form.Control
								ref={nameRef}
								type="text"
								placeholder="e.g. Communication Skills"
								onChange={(event: ChangeEvent<HTMLInputElement>) => {
									product.name = event.target.value;
								}}
							/>
						</Form.Group>
					</Col>
					<Col md={2}>
						<Form.Group>
							<Form.Label>Code</Form.Label>
							<Form.Control
								type="text"
								placeholder="e.g. CS101"
								onChange={(event: ChangeEvent<HTMLInputElement>) => {
									product.code = event.target.value;
								}}
							/>
						</Form.Group>
					</Col>
					<Col md={4}>
						<Form.Group>
							<Form.Label>Bundles</Form.Label>
							<BundleSelect
								defaultValue={product.bundles.map((bundle: Bundle) => {
									return {
										value: bundle.id,
										label: bundle.name,
									};
								})}
								handleChange={_selected => {
									product.bundles = _selected;
								}}
							/>
						</Form.Group>
					</Col>
					<Col md={2} className="d-flex align-items-end">
						<Form.Group className="w-100">
							<Button
								onClick={handleSubmit}
								disabled={submitting}
								className="w-100"
							>
								{submitting ? (
									<>
										<i className="fa fa-spinner fa-spin" /> Creating...
									</>
								) : (
									"Create"
								)}
							</Button>
						</Form.Group>
					</Col>
				</Row>
			</Form>
		</>
	);
};
